import { IconCoins } from '@/app/common/icons/libraryIcons';
import styled from 'styled-components';

export const StyledIconCoins = styled(IconCoins)`
  color: ${(p) => p.theme.commons.colors.gray400};
  min-height: 16px;
  min-width: 16px;
`;
